export const descriptions = {
  allstars: {
    avatar: require("../assets/img/characters/allstars.svg"),
    description: "Бокстоп из Destruction All Stars"
  },
  astroplayroom: {
    avatar: require("../assets/img/characters/astroplayroom.svg"),
    description: "Бот из Astro's Playroom"
  },
  bloodborne: {
    avatar: require("../assets/img/characters/bloodborne.svg"),
    description: "Леди Мария из Bloodborne"
  },
  concretegenie: {
    avatar: require("../assets/img/characters/concretegenie.svg"),
    description: "Злой джинн из «Городских духов»"
  },
  darksouls: {
    avatar: require("../assets/img/characters/darksouls.svg"),
    description: "Король Аллант из Demon's Souls"
  },
  daysgone: {
    avatar: require("../assets/img/characters/daysgone.svg"),
    description: "Баньши из «Жизнь после»"
  },
  ghostoftsusima: {
    avatar: require("../assets/img/characters/ghostoftsusima.svg"),
    description: "Хотун-хан из «Призрака Цусимы»"
  },
  godofwar: {
    avatar: require("../assets/img/characters/godofwar.svg"),
    description: "Бальдр из God of War"
  },
  littlebigplanet: {
    avatar: require("../assets/img/characters/littlebigplanet.svg"),
    description: "Сэкбой из LittleBigPlanet",
    additional: "Увеличивает атаку в два раза на один ход"
  },
  ratchetclanc: {
    avatar: require("../assets/img/characters/ratchetclanc.svg"),
    description: "Доктор Нефариус из Ratchet and Clank"
  },
  uncharted: {
    avatar: require("../assets/img/characters/uncharted.svg"),
    description: "Надин Росс из «Uncharted 4: Путь вора»"
  },
  untildawn: {
    avatar: require("../assets/img/characters/untildawn.svg"),
    description: "Маньяк из «Дожить до рассвета»"
  },
  thelastofus: {
    avatar: require("../assets/img/characters/thelastofus.svg"),
    description: "Кликер из «Одни из нас: Часть II»"
  }
};

export default function getCharDescription(character) {
  return descriptions[character];
}
